module.exports = __webpack_public_path__ + "img/logo_square.39f6abe1.png";